<template>
  <li>
    <span v-if="training.lessons" v-on:click="showChildren = !showChildren" :class="{plusMinus: true, showChildren: showChildren}"> {{ showChildren ? '-' : '+'}} </span>
    <span v-on:click="selectItem(training.id)" class="title">{{ training.title }}</span>
		<ul v-if="training.lessons && showChildren">
     <list-item v-for="item in training.lessons" :training="item" :key="item.id"></list-item>
		</ul>
  </li>
</template>

<script>
  export default {
    name: 'listItem',
    props: ['training'],
    data () {
      return {
        showChildren: false
      }
    },
    methods: {
      selectItem (id) {
        this.$router.push({path: `/training/${id}`})
      }
    }
  }
</script>

<style lang="scss">
  .plusMinus {
    display: inline-block;
    padding: 5px 8px;
    width: 30px;
    text-align: center;
    background-color: rgba(black, 0.05);
    margin-right: 4px;
    border-radius: 3px;

    &:hover,
    &.showChildren {
      background-color: #2196f3;
      color: white;
    }
  }
  .title {
    display: inline-block;
    padding: 5px 8px;
    background-color: rgba(black, 0.05);
    border-radius: 3px;
    // margin-bottom: 3px;

    &:hover {
      background-color: rgba(black, 0.1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Training/list/listItem/index.vue